export default {
  init() {
    // JavaScript to be fired on all pages
    this.callModal();
    this.button();
    this.toggleFilter();
  },

  callModal() {
   $('.product-page__service-content_item__clicker').on('click', function () {
      $(this).parent().find('.product-page__service-content_item-popup').fadeIn(250);
    });

    $('.product-page__service-content_item-popup, .product-page__service-content_item-popup-close').on('click', (e) => {
      if ($(e.target).hasClass('product-page__service-content_item-popup') || $(e.target).hasClass('product-page__service-content_item-popup-close')) {
        $('.product-page__service-content_item-popup').fadeOut(250);
      }
    });
  },

  button() {
    $('.product-page__service-button').click(function (e) {
      e.preventDefault();
      $(this).fadeOut(250);
      $('.product-page__service-form').fadeIn(250);
    });
  },

  toggleFilter() {
    $('.shop-page__head-adaptive-filter').click(function () {
      $('.shop-page__sidebar').fadeToggle(250).addClass('active');
      if ($('.shop-page__sidebar').hasClass('active')) {
        $('.shop-page__sidebar-close').css('display', 'flex')
      } else {
        $('.shop-page__sidebar-close').css('display', 'none')
      }
    });

    $('.shop-page__sidebar-close').on('click', function () {
      $('.shop-page__sidebar').fadeOut(250);
    });
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.product-page__service-back').on('click', function (e) {
      e.preventDefault();
      location.reload();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce.js